import Navigo from 'navigo';
import {getPayloadForPopupTrue} from "../../../bark-core/src/components/new-request-flow/components/entry-service/create-bark-payload";
import {launchBarkModal} from "../../../bark-core/src/components/new-request-flow/components/entry-service/start-bark";
import { initBuyerAppBranchIO } from "@bark/bark-core/src/helpers";

export const routerUrl = () => {
	const router = new Navigo('/', { strategy: 'ALL' });

	router
		.notFound(async () => {
			// called when there is path specified but
			// there is no route matching
		})
		.on({ '*': multiRouteEntrypoint }).resolve();
};


export const multiRouteEntrypoint = async ({ params }) => {

    if (params && canPopup(params)) {
        let { locid: locationId, pt: postCodeType, alid, locact } = params;

        locationId = isNaN(Number(locationId)) ? -1 : Number(locationId);
        postCodeType ??= -1;

        const thePayloadFormdata = getPayloadForPopupTrue({
            locationId,
            postCodeType,
            alid,
            locact,
        });

        launchBarkModal(thePayloadFormdata);
		initBuyerAppBranchIO(10, 'marketing');
    }
};

function canPopup(params) {
    const formCanPopup = $('#project-create-form').attr('can-popup') !== undefined;
    const isPopupTurnedOffOnPage = $('.bark-journey-popup-off').length > 0;

    if (params) {
        if (params.autosearch) {
            return true;
        }
        if ((params.popup === 'true' || params.nrfp === 'true') && formCanPopup && !isPopupTurnedOffOnPage) {
            return true;
        }
    }
    return false;
}
